import { Injectable } from "@angular/core";
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
 
import { environment } from "./../environments/environment";

@Injectable()
export class FirebaseService {
    public Auth = null;
    public firebaseProvider: any;

    constructor() {}

    initFirebase() {  
       
        if (!firebase.apps.length) {
            firebase.initializeApp(environment.FIREBASE_CONFIG);
        } 

        this.firebaseProvider = new firebase.auth.GoogleAuthProvider();
        this.firebaseProvider.addScope("email");
        this.firebaseProvider.setCustomParameters({
            hd: "gramophone.co.in",
            prompt: "select_account"
        });
        this.Auth = firebase.auth();
    }
}



// WEBPACK FOOTER //
// ./src/services/firebase.service.ts